import { useEffect } from "react";

const Analytics = () => {
  useEffect(() => {
    const consent = localStorage.getItem("eduardoCookieConsent");
    const consentGranted = consent === "accepted";

    window.dataLayer = window.dataLayer || [];

    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    window.gtag("consent", "default", {
      ad_storage: "denied",
      analytics_storage: "denied",
      functionality_storage: "denied",
      personalization_storage: "denied",
      security_storage: "granted", 
    });

    const interval = setInterval(() => {
      if (typeof window.gtag === "function") {
        window.gtag("consent", "update", {
          ad_storage: consentGranted ? "granted" : "denied",
          analytics_storage: consentGranted ? "granted" : "denied",
          functionality_storage: consentGranted ? "granted" : "denied",
          personalization_storage: consentGranted ? "granted" : "denied",
          security_storage: "granted",
        });

        window.dataLayer.push({
          event: "cookie_consent_update",
          ad_storage: consentGranted ? "granted" : "denied",
          analytics_storage: consentGranted ? "granted" : "denied",
          functionality_storage: consentGranted ? "granted" : "denied",
          personalization_storage: consentGranted ? "granted" : "denied",
          security_storage: "granted",
        });

        clearInterval(interval); 
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return null;
};


export default Analytics;
